import Vue from 'vue'
import Component from 'vue-class-component'
import { includes } from 'ramda'
import dayjs from 'dayjs'
import {
  getModule,
} from 'vuex-module-decorators'
import relativeTime from 'dayjs/plugin/relativeTime'
import LocationStore from '../store/modules/location'
import UserStore from '../store/modules/user'
import EventBus from '../event-bus'

// You can declare a mixin as the same style as components.

dayjs.extend(relativeTime)

@Component
export default class MainMixin extends Vue {
  Location = getModule(LocationStore)

  User = getModule(UserStore)

  EventBus:any = EventBus

  $store:any

  $toast:any

  $bind:any

  $rtdbBind:any

  get uid() {
    if (!this.$store.getters.uid) return ''
    return this.$store.getters.uid
  }

  get location() {
    if (!this.$store.state.location) return ''
    return this.$store.state.location.data.id
  }

  get group() {
    if (!this.$store.state.location) return ''
    return this.$store.state.location.data.group
  }

  mdDate(x:any) {
    if (!x) return ''
    const d:Date|string = x.seconds ? x.toDate() : x
    return dayjs(d).format('ddd, MMM D, YYYY')
  }

  datetime(x:any) {
    if (!x) return ''
    return dayjs(x).format('MMM D, YYYY [ at ] h:mma')
  }

  smdatetime(x:any) {
    if (!x) return ''
    return dayjs(x).format('M/D/YY [ at ] h:mma')
  }

  relativeTime(x:any) {
    if (!x) return ''
    return dayjs(x).from(dayjs())
  }

  justDate(x = new Date()) {
    return dayjs(x).format('YYYY-MM-DD')
  }

  // eslint-disable-next-line func-names
  sMap = function (x:any) {
    // @ts-ignore
    return includes(x, this.showMap)
  }

  capitalize(x:string) {
    return x.charAt(0).toUpperCase() + x.slice(1)
  }

  // eslint-disable-next-line func-names
  getUserName = function (id:any) {
    // @ts-ignore
    const user = this.User.users.find(x => x.id === id)
    if (!user) return 'Loading User'
    return `${user.firstName} ${user.lastName}`
  }

  prettyPhone(x:string|number) {
    if (!x) {
      return null
    }
    const value = x.toString()
    if (value.length !== 12 || !/[+][1]\d{10}\b/.test(value)) {
      return 'Invalid Phone'
    } return `(${value.substr(2, 3)}) ${value.substr(5, 3)}-${value.substr(8, 4)}`
  }

  dbPhone(x:string|number) {
    const value = x.toString()
    if (value.length !== 14 || !/[(]\d{3}[)][\s]\d{3}[-]\d{4}\b/.test(value)) {
      return 'Invalid Phone'
    }
    return `+1${value.substr(1, 3)}${value.substr(6, 3)}${value.substr(10, 4)}`
  }
}
